import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EdiText from 'react-editext';
import './SubStages.css';
import {
  postTempConfigFile,
  setTempConfigFile
} from '../../../../../../actions/index';
import funcTranslateHelper from '../../../../../../i18next/funcTranslateHelper';
import { editBuilderProcess } from '../../../../OnEdit/onEdit';
import { connect } from 'react-redux';

const useStyles = makeStyles({
  card: {
    height: '100%',
    minHeight: '90px',
    backgroundColor: 'white',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10
  },
  content: {
    padding: '0px',
    height: '100%',
    '&:last-child': {
      paddingBottom: '20px'
    },
    position: 'relative'
  },
  bottom: {
    position: 'absolute',
    bottom: 0,
    height: 4,
    width: '100%'
  }
});

function SubStages ({
  stages,
  assets,
  configFile,
  setConfigFile,
  saveTempConfigFile
}) {
  const classes = useStyles();
  async function onSave (e) {
    // Edit substage
    let config = configFile;
    config = await editBuilderProcess(configFile, stages.id, e);

    const res = await postTempConfigFile(config);
    if (res.message === 'OK') {
      saveTempConfigFile(config);
    }
  }

  const disableBuilder = configFile.disableBuilder;

  return (
    <div>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          {disableBuilder
            ? (
              <Typography
                className={classes.title}
                color='textSecondary'
                style={{
                  fontFamily: 'Roboto-Regular',
                  fontWeight: '500',
                  lineHeight: '22px',
                  fontSize: '20px',
                  color: 'rgba(0,0,0,0.87)',
                  paddingTop: 19,
                  paddingLeft: 18.4,
                  marginBottom: 0,
                  width: 148
                }}
                gutterBottom
              >
                {funcTranslateHelper(stages.name)}
              </Typography>
            )
            : (
              <div
                className={classes.title}
                color='textSecondary'
                style={{
                  fontFamily: 'Roboto-Regular',
                  fontWeight: '500',
                  lineHeight: '22px',
                  fontSize: '20px',
                  color: 'rgba(0,0,0,0.87)',
                  paddingTop: 19,
                  paddingLeft: 18.4,
                  marginBottom: 0
                }}
              >
                <EdiText
                  type='text'
                  value={funcTranslateHelper(stages.name)}
                  onSave={onSave}
                  canEdit={false}
                />
              </div>)}
          <Typography
            className={classes.items}
            color='textSecondary'
            style={{
              fontFamily: 'Roboto-Regular',
              fontWeight: '500',
              fontSize: '14px',
              color: 'rgba(0,0,0,0.60)',
              letterSpacing: '0.25px',
              textAlign: 'left',
              lineHeight: '20px',
              paddingTop: 11,
              paddingLeft: 18.4,
              marginBottom: 0,
              width: 148
            }}
            gutterBottom
          >
            Items
          </Typography>
          <div className={classes.bottom} style={{ background: '#78A9FF' }} />
        </CardContent>
      </Card>
    </div>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    saveTempConfigFile: data => dispatch(setTempConfigFile(data))
  };
};

export default connect(null, mapDispatchToProps)(SubStages);
